/* eslint-disable no-unused-vars */
import { useCallback } from 'react';
import { Palette } from 'config';
import { TableCell } from 'components';

const styleTableCell = {
  borderBottom: `1px solid ${Palette.PrimaryGray._200}`,
  userSelect: 'none',
};

const colNamesMap = {
  Impressions: 'impressions',
  Clicks: 'clicks',
  Installs: 'installs',
  CTR: 'ctr1',
  Earning: 'earning',
  eCPM: 'eCPM1',
};

export const HeaderItem = ({ column, HEADER_ROW_HEIGHT, sortConfig$ }) => {
  // const colName = column === 'eCPM' ? column : column.toLowerCase();

  const requestSort = (key) => {
    let direction = 'ascending';
    if (
      sortConfig$.value &&
      sortConfig$.value.key === key &&
      sortConfig$.value.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    sortConfig$.value = { key, direction };
  };

  const getClassNamesFor = useCallback(
    (name) => {
      if (!sortConfig$.value) {
        return;
      }
      return sortConfig$.value.key === name ? sortConfig$.value.direction : undefined;
    },
    [sortConfig$.value],
  );

  return (
    <TableCell.Component
      size={TableCell.sizes[HEADER_ROW_HEIGHT]}
      value={colNamesMap[column]}
      onClick={requestSort}
      direction={getClassNamesFor(colNamesMap[column])}
      style={styleTableCell}
    >
      {column}
    </TableCell.Component>
  );
};
